import BenefitsForm from './component';

export default BenefitsForm;
